import React from "react";
import { Button, Typography } from "antd";
import { MailOutlined } from "@ant-design/icons";
import cashFlowImage from "../../assets/images/cash-flow-403-image.png";
const { Title, Text } = Typography;

const CashFlowNotAuthorize = ({ supportEmail }) => {
  const handleSendMail = () => {
    const email = supportEmail || "destek@finekra.com";
    window.location.href = `mailto:${email}?subject=Nakit Akış Raporu Aktivasyonu`;
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        textAlign: "center",
      }}
    >

      <img
        src={cashFlowImage}
        alt="403"
        style={{
          width: 550,
          maxWidth: "80%",
          marginBottom: 32,
          marginTop: "-100px",
        }}
      />


      <Title
        level={3}
        style={{
          marginBottom: 8,
          fontWeight: 600,
          color: "#000",
        }}
      >
        Nakit Akış Raporu Aktif Değil
      </Title>

      <Text
        style={{
          fontSize: 15,
          color: "rgba(0,0,0,0.65)",
          marginBottom: 32,
        }}
      >
        Nakit Akış Raporu henüz aktif değil, etkinleştirmek için <br />
        destek ekibiyle iletişime geçin.
      </Text>

      {/* Buton */}
      <Button
        type="primary"
        icon={<MailOutlined />}
        onClick={handleSendMail}
        size="middle"
      >
        E-Posta Gönder
      </Button>
    </div>
  );
};

export default CashFlowNotAuthorize;
